import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import sendNotification from '../../../../../notifications/sendNotification';
import { SessionComplianceChecklistItem } from '../../Contexts/SessionComplianceContextProvider/type';

export default function useTriggerReminder() {
  const { t } = useTranslation('notifications');
  const { enqueueSnackbar } = useSnackbar();

  return (topic: SessionComplianceChecklistItem) => {
    sendNotification({
      type: 'compliance-reminder',
      title: topic.topic.text,
    });
    enqueueSnackbar(t('reminder-compliance-task.title', { title: topic.topic.text }), {
      variant: 'warning',
    });
  };
}
